import script from "./CompetitionsRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./CompetitionsRoute.vue?vue&type=script&setup=true&lang=js"

import "./CompetitionsRoute.vue?vue&type=style&index=0&id=7e75d484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e75d484"]])

export default __exports__